// extracted by mini-css-extract-plugin
export default {"buttons":"ButtonBar-module--buttons--63caf","back":"ButtonBar-module--back--94dc6","next":"ButtonBar-module--next--5b0c8","slideIn":"ButtonBar-module--slideIn--88082"};